import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { loggedUserApi } from "redux/api/loggedUserApi";
import { FullScreenLoader } from "components";

interface PrivateRouteProps {
  children: ReactNode;
  allowedRoles: string[];
}

export const PrivateRoute = (props: PrivateRouteProps) => {
  const { children, allowedRoles } = props;

  const { isLoading, isFetching, isError } =
    loggedUserApi.endpoints.getMe.useQuery(null, {
      skip: false,
      refetchOnMountOrArgChange: true,
    });

  const loading = isLoading || isFetching;

  const { data: user } = loggedUserApi.endpoints.getMe.useQueryState(null, {
    selectFromResult: (data: any) => data,
  });
  

  if (loading) {
    return <FullScreenLoader />;
  }

  if (!user || isError) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};
